import { EmailInviteStatusEnum, IEmailInvite } from '../types/user'

export interface IInviteStatusUser {
  email?: string
  isGhostUser?: boolean
  initialUser?: boolean
}

export const buildInviteStatusByEmail = (invites: Partial<IEmailInvite>[]): Map<string, EmailInviteStatusEnum> => {
  const byEmail = new Map<string, EmailInviteStatusEnum>()
  for (const invite of invites) {
    if (invite.status !== EmailInviteStatusEnum.pending && invite.status !== EmailInviteStatusEnum.expired) {
      continue
    }
    if (invite.email) {
      byEmail.set(invite.email.toLowerCase(), invite.status)
    }
    if (invite.updatedEmail) {
      byEmail.set(invite.updatedEmail.toLowerCase(), invite.status)
    }
  }
  return byEmail
}

export const getEmailInviteStatus = (user: IInviteStatusUser, inviteStatusByEmail: Map<string, EmailInviteStatusEnum>): EmailInviteStatusEnum => {
  if (!user.isGhostUser || user.initialUser) {
    return EmailInviteStatusEnum.accepted
  }
  return (user.email && inviteStatusByEmail.get(user.email.toLowerCase())) || EmailInviteStatusEnum.notInvited
}
